import { Chip } from "@mui/material";
import React from "react";
import * as BusinessConst from "../utils/businessconstants";

//get statusId values from business constants
const MuiChip = ({ row, statusKey }) => {
  let txtcolor = null;
  let bgcolor = null;
    let txtlabel = null;
    const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
    if (row !== null && row !== undefined) {
        switch (statusKey) {
            case BusinessConst.shipment_status:
                let rowvalue = Array.isArray(row) ? row[0] : row;
                txtlabel = rowvalue.deliveryStatus;
                switch (rowvalue["deliveryStatusKey"]) {
                    case BusinessConst.shipment_delivery_open_Lookupname:
                        txtcolor = "#ad1457";
                        bgcolor = "#fce4ec";
                        break;
                    case BusinessConst.shipment_delivery_pick_Lookupname:
                        txtcolor = "#e8b020";
                        bgcolor = "#fff9c485";
                        break;
                    case BusinessConst.shipment_delivery_shipping_Lookupname:
                        txtcolor = "#AA5B00";
                        bgcolor = "#FCF2E6";
                        break;
                    case BusinessConst.shipment_delivery_delivered_Lookupname:
                        txtcolor = "#2264E5";
                        bgcolor = "#EBF0FA";
                        break;
                    default:
                        txtcolor = "#c27b3d";
                        bgcolor = "#f9f2ec";
                        txtlabel = "-";
                }
                break;
            case BusinessConst.pod_status:
                let podRowValue = Array.isArray(row) ? row[0] : row;
                txtlabel = podRowValue.podStatus;
                switch (podRowValue["podStatusKey"]) {
                    case BusinessConst.POD_Delivered_Lookupname:
                        txtcolor = "#14804A";
                        bgcolor = "#E1FCEF";
                        break;
                    case BusinessConst.POD_Reviewed_Lookupname:
                        txtcolor = "#27AE60";
                        bgcolor = "#E0E0E0";
                        break;
                    default:
                        txtcolor = "#c27b3d";
                        bgcolor = "#f9f2ec";
                        txtlabel = "-";
                }
                break;
            case BusinessConst.active_status:
                let statusRowValue = Array.isArray(row) ? row[0] : row;
                if (statusRowValue !== undefined) {
                    switch (statusRowValue["isActive"]) {
                        case true:
                            txtcolor = "#14804A";
                            bgcolor = "#E1FCEF";
                            txtlabel = translatedText?.active//"Active";
                            break;
                        case false:
                            txtcolor = "#AA5B00";
                            bgcolor = "#FCF2E6";
                            txtlabel = translatedText?.in_active//"Inactive";
                            break;
                        default:
                            txtcolor = "#c27b3d";
                            bgcolor = "#f9f2ec";
                            txtlabel = "-";
                    }
                }
                break;
            default:
                txtcolor = "#c27b3d";
                bgcolor = "#f9f2ec";
                txtlabel = "-";
        }
    }
  return (
    <Chip
      label={txtlabel}
      variant="outlined"
      size="small"
      sx={{ color: txtcolor, background: bgcolor, border: bgcolor }}
    ></Chip>
  );
};

export default MuiChip;
